module.exports = __webpack_public_path__ + "static/media/callahan-react.f252b9ea.scss";


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/scss/callahan-react.scss
// module id = 182
// module chunks = 0